<template>
  <div>
    <svg :height="svgHeight" viewBox="0 0 600 400" :width="svgWidth">
      <g>
        <path
          :class="color"
          d="M205.4,41.6c4.5,1.9,7.7,4.5,9.8,8c2.1,3.5,3.2,7.4,3.4,11.9c0.2,4.5-0.3,9.2-1.4,14.3c-1.1,5-2.6,10-4.5,14.8
		c-1.9,4.9-4,9.4-6.3,13.7c-2.3,4.3-4.4,7.9-6.3,10.9c-12.3,19.2-25.8,35.2-40.5,47.9c-14.7,12.7-31,23.2-49.1,31.6
		c-3,8.2-5.3,15.7-7,22.5c-1.7,6.8-3,13.2-3.9,19.2c20.2-2.6,36.9-1.7,50.1,2.8c5.6,1.9,10.9,5.3,15.8,10.2
		c4.9,4.9,8.9,10.3,11.9,16c3,5.7,4.7,11.2,5,16.4c0.4,5.2-1.2,9.1-4.8,11.5c0-6.9-2-12.8-6-17.6c-4-4.9-9.4-8.7-16.2-11.5
		c-6.8-2.8-14.9-4.5-24.2-5c-9.3-0.6-19.3,0.1-29.8,2.1c-10.5,2-21.6,5.2-33,9.7c-11.5,4.5-22.8,10.3-34,17.4c-1.9,1.3-4.2,1-7.1-1
		c-2.9-2-5.5-4.5-7.7-7.6c-2.2-3.1-3.8-6.2-4.8-9.4c-0.9-3.2-0.4-5.5,1.7-7c9-4.3,17.9-8.2,26.7-11.6c8.9-3.5,17.5-6.3,25.9-8.5
		c0.6-5.8,1.7-12.4,3.5-19.7c1.8-7.4,3.7-14.8,5.7-22.3c-1.1,0.4-3.4,0.7-6.9,0.8c-3.5,0.2-7.3,0.3-11.6,0.4
		c-4.3,0.1-8.7,0-13.3-0.3c-4.6-0.3-8.6-0.8-12.2-1.5c-7.5-1.7-13.2-4.9-17.2-9.5c-4-4.7-6.7-9.6-8.1-14.7
		c-1.4-5.1-1.7-9.8-0.8-14.1c0.8-4.3,2.3-6.8,4.3-7.6c-0.2,3.7,1.1,7,3.9,9.8s6.4,5.1,10.9,7c4.5,1.9,9.5,3.4,15.1,4.6
		c5.6,1.2,11.2,2,16.8,2.4c5.6,0.4,10.8,0.4,15.5,0.1c4.8-0.3,8.6-0.9,11.6-1.8c5.4-15.1,11.4-30.1,18.1-44.8
		c6.6-14.7,15-29.8,25.1-45.1c3.7-6,8.3-12.3,13.6-18.9c5.3-6.6,11.2-12.4,17.6-17.4c6.4-4.9,13.4-8.5,21-10.6
		C189.3,37.9,197.2,38.4,205.4,41.6z M168.7,81.3c-4.9,6.2-9.7,12.9-14.4,20.2c-4.8,7.3-9.3,14.7-13.7,22.3
		c-4.4,7.6-8.4,15-12.2,22.4c-3.7,7.4-6.8,14.2-9.2,20.6c6.9-2.8,14-7,21.1-12.6c7.2-5.6,14-11.9,20.4-19
		c6.4-7.1,12.3-14.6,17.6-22.4c5.3-7.8,9.7-15.5,13-23c4.5-9.7,7.3-17.5,8.4-23.2c1.1-5.8,0.7-9.2-1.3-10.4c-2-1.1-5.5,0.3-10.5,4.3
		C183,64.5,176.6,71.4,168.7,81.3z"
        />
        <path
          :class="color"
          d="M235.9,172.3c0.9-1.3,2.1-2,3.4-2.1c1.3-0.1,2.5,0.1,3.5,0.7c1,0.6,1.9,1.3,2.5,2.2c0.7,0.9,0.7,1.9,0.1,2.8
		c-2.1,4.3-5,9.9-9,16.8c-3.9,6.9-8.2,13.8-12.9,20.7c-4.7,6.9-9.5,13.2-14.4,18.8c-4.9,5.6-9.4,9.2-13.3,10.9
		c-2.4,0.9-5.2,1.2-8.4,0.8c-3.2-0.4-6.2-1.3-9-2.7c-2.8-1.4-5.1-3.3-7-5.6c-1.9-2.3-2.7-5-2.5-8c0.2-3.7,1-8.7,2.4-15
		c1.4-6.3,3.3-12.9,5.6-19.9c2.3-7,4.9-13.9,7.7-20.7c2.8-6.8,5.7-12.6,8.7-17.5c0.9-1.5,2.8-2.2,5.7-2.2c2.9,0,5.7,0.6,8.5,1.7
		c2.8,1.1,5.1,2.6,7,4.5c1.9,1.9,2.3,3.8,1.4,5.9c-8.8,16.8-14.7,29.9-17.9,39.3c-3.2,9.4-4.2,15.5-3.1,18.3
		c0.7,2.1,2.3,2.3,4.8,0.7c2.4-1.6,5.5-4.6,9.1-9.1c3.6-4.5,7.8-10.3,12.5-17.4C226,189.3,230.9,181.3,235.9,172.3z M218.3,142.9
		c-1.1,1.5-2.8,2.3-4.9,2.5c-2.1,0.2-4.3,0-6.4-0.7c-2.1-0.7-4-1.6-5.6-2.9c-1.6-1.3-2.3-2.7-2.1-4.2c0.4-2.6,1-5.4,1.8-8.3
		c0.8-2.9,1.7-5.6,2.7-8.1c0.9-2.5,1.9-4.8,2.8-6.9c0.9-2.1,1.7-3.6,2.2-4.8c1.1-1.7,3.2-2.6,6.2-2.7c3-0.1,5.9,0.4,8.8,1.5
		c2.9,1.1,5.3,2.6,7.1,4.5c1.9,1.9,2.2,3.7,1.1,5.6c-0.6,1.1-1.4,2.8-2.7,4.9c-1.2,2.1-2.5,4.4-3.8,6.7c-1.3,2.3-2.6,4.6-3.9,6.9
		C220.3,139.3,219.2,141.3,218.3,142.9z"
        />
        <path
          :class="color"
          d="M320.8,168.7c2.6-0.4,5.6,0.3,9,2c3.4,1.7,5.8,3.2,7.3,4.5c-0.7,0.7-1.3,1.2-1.5,1.3c-0.3,0.1-0.6,0.1-1,0
		c-0.4-0.1-0.9-0.2-1.5-0.4c-0.7-0.2-1.5-0.2-2.7,0c-2.8,0.6-6.9,2.4-12.3,5.5c-5.4,3.1-11,6.5-16.8,10.4
		c-5.8,3.8-11.2,7.6-16.1,11.2c-4.9,3.6-8.2,6.3-9.7,8c0.9,1.5,1.9,2.9,2.8,4.2c0.9,1.3,1.9,2.7,2.8,4.2c2.8,5,4,10.1,3.6,15.1
		c-0.4,5-1.9,9.9-4.6,14.7c-2.7,4.8-6.3,9.2-10.8,13.3c-4.5,4.1-9.2,7.6-14.3,10.4c-3.4,1.9-7.1,3.2-11.3,4.1
		c-4.2,0.8-8.3,1.1-12.3,0.8c-4-0.3-7.7-1.1-11.2-2.4c-3.5-1.3-6.2-3.2-8.1-5.7c-2-2.5-3-5.6-3.1-9.1c-0.1-3.5,1.3-7.7,4.1-12.3
		c4.3-7.1,9.8-13.7,16.7-19.9c6.8-6.2,13.8-11.9,20.9-17.4c-3.4-4.9-6.8-9.5-10.2-13.9c-3.5-4.4-5.8-9.3-7.1-14.7
		c-1.1-4.9-1.4-9.8-0.7-14.7c0.7-4.9,2-9.7,4.1-14.1c2.1-4.5,4.7-8.6,8-12.5c3.3-3.8,7-7.1,11.1-9.9c2.1-1.3,4.5-1.9,7.3-1.8
		c2.8,0.1,5.6,0.6,8.4,1.5c2.8,0.9,5.4,2.1,7.7,3.4c2.3,1.3,4.2,2.4,5.5,3.4c4.9-7.8,9.1-13.7,12.7-17.5c3.6-3.8,6.6-6.8,8.8-8.8
		c1.3-0.9,3.1-0.7,5.3,0.7c2.2,1.4,4.3,3.3,6.3,5.6c2,2.3,3.5,4.7,4.5,7.1c1,2.4,0.9,4.1-0.4,5c-3,2.1-6.5,5.3-10.6,9.8
		c-4.1,4.5-7.9,9.2-11.5,14.3c-3.5,5-6.3,9.9-8.3,14.7c-2,4.8-2.3,8.6-1,11.6c-0.9,0.4-2.2,0.3-3.8-0.3c-1.6-0.6-3.2-1.4-4.8-2.5
		c-1.6-1.1-3-2.6-4.3-4.3c-1.3-1.8-2.2-3.7-2.8-5.7c-0.4-1.5-0.4-3.2,0-5.2c0.4-2,0.8-3.9,1.4-5.7c0.6-1.9,1.2-3.6,2-5.3
		c0.7-1.7,1.3-3,1.7-3.9c-3.5-0.2-6.9,1.7-9.9,5.7c-3.1,4-5.4,8.8-6.9,14.4c-1.5,5.6-2.1,11.4-1.7,17.5c0.4,6.1,2.3,11.2,5.9,15.3
		c3.5-2.2,7.7-5,12.5-8.4c4.8-3.4,9.6-6.7,14.4-9.9c4.9-3.3,9.7-6.1,14.4-8.5C313.1,170.8,317.2,169.3,320.8,168.7z M230.3,260.3
		c2.6-0.2,5.7-1.6,9.4-4.3c3.6-2.7,7-5.9,10.1-9.7c3.1-3.7,5.5-7.6,7.3-11.5c1.8-3.9,2.1-7.1,1-9.5c-5.8,5.4-11.2,10.9-16.4,16.4
		C236.5,247.1,232.7,253.4,230.3,260.3z"
        />
        <path
          :class="color"
          d="M441.4,89.2c6.9,1.9,11.8,5.3,14.6,10.4c1.5,2.2,2.6,4.6,3.2,7c0.7,2.4,0.9,4.8,0.7,7c-0.4,2.6-0.9,4.6-1.5,6
		c-0.7,1.4-1.8,2.6-3.5,3.5c1.1-8.4-5.9-14-21-16.8c-15.3-2.6-33.3-2.2-54,1.1c-15.3,20.9-28.4,44.1-39.2,69.4
		c-5.8,12.9-10.3,24.8-13.6,35.7c-3.3,10.9-5.4,21-6.3,30.4c-1.7,18.7,3.8,28,16.5,28c-6.7,6.7-15.1,7.9-25.2,3.6
		c-10.3-4.3-16.3-13.7-18.2-28.3c-0.2-6.5,0.8-14.4,2.9-23.7c2.1-9.2,5.6-20,10.2-32.3c4.9-12.3,10.1-24.5,15.7-36.7
		c5.6-12.1,11.8-24.2,18.5-36.1c-5.6,2.1-10.8,4.3-15.7,6.7c-4.9,2.4-9.4,5-13.7,7.8c-1.7,1.3-3.6,1.2-5.9-0.3
		c-2.2-1.1-4.5-3.2-6.7-6.2c-1.9-2.2-3.3-4.6-4.2-7c-0.6-2.6,0-4.4,1.7-5.3c9.1-4.1,18.6-7.8,28.3-11.1c9.7-3.3,19.9-6.2,30.5-8.8
		c3.7-6.2,7.5-11.6,11.2-16.2c3.7-4.7,7.3-8.8,10.6-12.3c2.6-2.2,6.3-2.2,11.2,0c4.7,1.9,8.4,4.8,11.2,8.7c2.6,3.9,2.4,7.7-0.6,11.2
		c-0.4,0.4-0.7,0.7-1,0.8c-0.3,0.2-0.6,0.5-1,0.8C414.2,85.3,428.9,86.2,441.4,89.2z M416.2,175.1c1.7-1.7,3.4-2.2,5-1.7
		c0.9,0,1.8,0.2,2.5,0.7c0.7,0.5,1.4,1,2,1.5c0.9,1.3,1.3,2.6,1.1,3.9c-1.7,2.6-3.6,5.9-5.9,9.9c-2.2,4-4.8,8.4-7.6,13.3
		c-2.8,4.9-5.9,9.5-9.2,13.9c-3.4,4.4-7,8.4-10.9,12.2c-7.8,7.5-14.9,12.2-21.3,14.3c-5.8,1.9-12.1,0.9-19-2.8
		c-6.7-3.4-10.1-8.3-10.1-14.8c0.6-4.3,1.7-9.3,3.5-15c1.8-5.7,4.2-12.3,7.1-19.7c6.2-14.7,12.8-27.3,19.9-37.5
		c1.9-1.9,5-2.2,9.5-1.1c4.3,0.7,8.3,2.4,12,5c3.2,2.6,4.2,5.2,3.1,7.8c-22.4,37.9-30.1,56.4-23.2,55.4
		C381.7,219.9,395.5,204.8,416.2,175.1z M405.6,144.9c-1.7,2.1-4.2,2.8-7.6,2.2c-3.7-0.6-6.8-1.7-9.2-3.4c-3-1.7-4.3-3.5-3.9-5.3
		c0.9-2.8,1.8-5.6,2.7-8.4c0.8-2.8,1.9-5.5,3.2-8.1c1.3-2.6,2.5-4.9,3.5-6.7c1-1.9,1.9-3.4,2.7-4.5c2.1-2.4,5.4-3.2,10.1-2.2
		c2.4,0.6,4.7,1.2,6.7,2c2.1,0.7,3.9,1.7,5.6,2.8c1.9,1.5,3,2.8,3.4,4.1c0.4,1.2,0.3,2.6-0.3,4.1c-0.6,0.7-1.1,1.5-1.7,2.2
		c-0.6,0.7-1.2,1.7-2,2.8c-0.9,1.5-2,3.1-3.1,4.8c-1.1,1.7-2.2,3.4-3.4,5c-1.3,1.5-2.5,3-3.5,4.5
		C407.8,142.2,406.7,143.6,405.6,144.9z"
        />
        <path
          :class="color"
          d="M482.6,177.4c1.1-0.7,2.1-0.7,3.1,0.3c0.9,0.9,1.6,2.2,2,3.8c0.4,1.6,0.4,3.3,0,5c-0.4,1.8-1.2,3-2.5,3.8
		c-6.2,4.9-13.4,7.9-21.7,9.2c-8.3,1.3-16.7,1.2-25.1-0.3c3.7,2.8,6.3,6.4,7.8,10.8c1.5,4.4,2.2,9.2,2.1,14.4
		c-0.1,5.2-0.8,10.7-2.2,16.4c-1.4,5.7-3.1,11.2-5.2,16.5c-2.1,5.3-4.3,10.3-6.7,14.8c-2.4,4.6-4.7,8.4-6.7,11.3
		c-3.7,5.6-8.1,8.7-13.2,9.4c-5,0.7-10.7,0.2-17.1-1.3c-3.7-0.7-6.5-2.2-8.4-4.5c-1.9-2.2-3.2-4.8-4.1-7.7c-0.8-2.9-1.3-6-1.3-9.2
		s0.2-6.3,0.6-9.1c0.6-5,2.1-12,4.6-20.9c2.5-8.9,5.7-18.7,9.5-29.4c3.8-10.7,8.2-21.8,13.2-33.3c4.9-11.5,10.2-22.4,15.8-32.8
		c5.6-10.4,11.4-19.6,17.4-27.9c6-8.2,11.9-14.4,17.6-18.5c1.9-1.3,4.3-1.3,7.3,0.1c3,1.4,5.7,3.4,8.3,6c2.5,2.6,4.3,5.4,5.5,8.3
		c1.1,2.9,0.7,5.2-1.4,6.9c-4.7,3.4-9.2,7.4-13.6,12c-4.4,4.7-8.5,9.7-12.5,15.1c-3.9,5.4-7.5,11-10.6,16.8
		c-3.2,5.8-5.8,11.5-7.8,17.1c3.5,1.7,7.4,2.8,11.5,3.5c4.1,0.7,8.2,0.8,12.2,0.6c4-0.3,7.9-1,11.6-2.2
		C476.2,181.3,479.6,179.6,482.6,177.4z M409.5,274.5c2.4-2.8,4.9-6.5,7.3-11.1c2.4-4.6,4.6-9.4,6.6-14.4s3.5-10.1,4.8-15.1
		c1.2-5,1.7-9.5,1.5-13.4c0-2.1-0.2-4.2-0.7-6.3c-0.5-2.1-1.4-4.2-2.7-6.3c-0.7,1.3-1.6,3.3-2.7,6c-1,2.7-2.1,5.6-3.1,8.7
		c-1,3.1-2,6-2.9,8.8c-0.9,2.8-1.7,5-2.2,6.7c-1.9,5.8-3.5,11.8-4.8,18.1C409.3,262.5,409,268.6,409.5,274.5z"
        />
        <path
          :class="color"
          d="M587.9,174.6c1.9-0.9,3.3-0.9,4.2,0.1c0.9,1,1.4,2.5,1.3,4.5c-0.1,2-0.7,4.2-1.8,6.6c-1.1,2.4-2.9,4.5-5.3,6.2
		c-7.3,4.5-14,8.9-20.3,13.3c-6.3,4.4-12.3,9-18.1,13.9c-2.6,2.1-4.6,4.4-5.9,7c-3.7,7.7-8.1,16.1-13.2,25.5
		c-5,9.3-10.5,18.2-16.5,26.7c-6,8.5-12.2,16.1-18.8,22.8c-6.5,6.7-13,11.3-19.3,13.7c-2.4,0.9-5.8,0.9-10.1-0.1
		c-4.3-1-8.2-2.9-11.6-5.6c-3.5-2.7-5.9-6.2-7.3-10.4c-1.4-4.2-0.4-9,2.9-14.4c4.3-6.9,10.2-14,17.6-21.4c7.5-7.4,15-14.2,22.5-20.6
		c7.6-6.3,14.3-11.9,20.2-16.8c5.9-4.9,9.3-8.2,10.2-10.1c0.9-1.9,2-4.2,3.2-7.1c1.2-2.9,2.4-5.9,3.5-9c1.1-3.1,2.2-6.1,3.4-9
		c1.1-2.9,2-5.4,2.5-7.4c-2.8,4.7-6,9.4-9.7,14.1c-3.6,4.8-7.3,9.3-11.1,13.6c-3.7,4.3-7.5,8.2-11.3,11.8c-3.8,3.5-7.4,6.4-10.8,8.7
		c-2.1,1.3-4.8,1.7-8.1,1.1c-3.4-0.6-6.6-1.7-9.7-3.4c-3.1-1.7-5.6-3.8-7.7-6.3c-2.1-2.5-2.8-5.1-2.2-7.7c0.9-4.7,2.4-10,4.3-16.1
		c2-6.1,4.2-12.2,6.9-18.5c2.6-6.3,5.6-12.3,9-18.1c3.4-5.8,6.9-10.9,10.6-15.4c1.3-1.5,3.4-2.1,6.3-1.7c2.9,0.4,5.7,1.3,8.4,2.7
		c2.7,1.4,4.8,3.1,6.3,5.2c1.5,2.1,1.4,4-0.3,5.9c-2.2,2.6-5,6.7-8.3,12.3c-3.3,5.6-6.2,11.2-8.8,16.8c-2.6,5.6-4.5,10.5-5.7,14.6
		c-1.2,4.1-1,6,0.7,5.6c1.7-0.4,4.1-2.3,7.3-5.9c3.2-3.5,6.7-7.9,10.6-13.2c3.9-5.2,8-11,12.3-17.2c4.3-6.3,8.3-12.3,12-18.1
		c3.7-5.8,7-11,9.9-15.5c2.9-4.6,4.9-7.9,6-9.9c1.1-1.7,3-2.5,5.6-2.4c2.6,0.1,5.3,0.7,8.1,2c2.8,1.2,5.2,2.8,7.1,4.6
		c2,1.9,2.8,3.6,2.4,5.3c-0.6,3.9-1.5,8.5-2.9,13.7c-1.4,5.2-2.9,10.6-4.6,16.1c-1.7,5.5-3.3,10.7-4.8,15.7
		c-1.5,4.9-2.7,9.1-3.6,12.5c6.9-5,12.7-9.1,17.4-12.2C577.7,180.6,582.6,177.6,587.9,174.6z M461.6,297.8c3-2.2,6.2-5,9.5-8.3
		c3.4-3.3,6.7-6.9,9.9-10.8c3.3-3.9,6.4-7.9,9.4-12c3-4.1,5.6-8.1,7.8-12c-3.4,3.2-7.1,6.9-11.3,11.1c-4.2,4.2-8.1,8.4-11.8,12.5
		c-3.6,4.1-6.8,7.9-9.4,11.5C463.2,293.2,461.8,295.9,461.6,297.8z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "listifyNameSvg",
  props: {
    width: Number,
    height: Number,
    color: String,
  },
  computed: {
    svgWidth: function () {
      if (this.width && this.width > 0) {
        return this.width;
      }
      return "100%";
    },
    svgHeight: function () {
      if (this.height && this.height > 0) {
        return this.height;
      }
      return "100%";
    },
  },
};
</script>

<style type="text/css">
.primary {
  fill: var(--v-primary-base);
}

.background {
  fill: var(--v-background-base);
}
</style>